import MaterialFormHelperText, {
    FormHelperTextProps,
} from '@mui/material/FormHelperText';

export function FormHelperText(props: FormHelperTextProps) {
    return (
        <MaterialFormHelperText
            data-testid={'FormHelperText-container'}
            {...props}
        />
    );
}

export default FormHelperText;
